import moment from "moment-jalaali";

export const jalaliDateTimeForFileName = ()=>{
    

    const now = moment();
    const jYear = now.jYear().toString().padStart(4, '0'); 
    const jMonth = now.jMonth() + 1;
    const jDay = now.jDate();  
    const jHour = now.hour();
    const jMinute = now.minute();

    return `${jYear}${jMonth}${jDay}${jHour}${jMinute}`; 
}

